import { render, staticRenderFns } from "./StartExercise.vue?vue&type=template&id=38f31c74&"
import script from "./StartExercise.vue?vue&type=script&lang=js&"
export * from "./StartExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports